exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading-box[data-v-0552bf66]{margin-top:200px}", ""]);

// exports
